import styled, { css } from "styled-components";
import courseraImage from "@assets/images/coursera.png";
import udemyImage from "@assets/images/udemy.png";
import { CourseProvider } from "@domain/lms/course/course";

export const CourseProviderIcon = styled.div.withConfig({
	shouldForwardProp: (prop) => prop !== "provider",
})<{ provider: CourseProvider }>`
	width: 49px;
	height: 14px;
	${({ provider }) =>
		providerIcons[provider] &&
		css`
			background-image: url(${providerIcons[provider]});
			background-size: contain;
			background-repeat: no-repeat;
		`};
`;

export const providerIcons: { [key in CourseProvider]?: string } = {
	UDEMY: udemyImage,
	COURSERA: courseraImage,
};
